import {Wall, WallConfig} from "./Wall";
import {Vector3, Mesh} from "three";

export interface EndWallConfig
{
	id: string;
	normal: Vector3;
	original: Mesh;
	current: Mesh;
	isSideWall: boolean;
	roof?: Mesh; // todo rename pitch
	roofOriginal?: Mesh; // todo rename pitch
}

export class EndWall extends Wall
{
	public roof: Mesh;
	public roofOriginal: Mesh; // we need to store the original for the addon-cutting.

	constructor(config: EndWallConfig)
	{
		const wallConfig = config;
		wallConfig.isSideWall = false;
		super(wallConfig);

		this.roof = config.roof;
		this.roofOriginal = config.roof;

		if (this.roof)
		{
			this.roof.castShadow = true;
		}
	}

	public hideRoof()
	{
		this.roof.visible = false;
	}
	public showRoof()
	{
		this.roof.visible = true;
	}
}
